<template>
  <div class="row f-row container-uploadFile">
    <div
      class="markets-chart-title col col-12 d-flex align-items-center container-title"
      style="font-size: 0.95rem!important;"
    >
      Files Available for Data Upload
    </div>
    <messages :modal_message="loading" :colorTheme="colorTheme" @handlerAcceptModal="clearValuesModal" />
    <div v-if="loading.allData" class="container_progress-spiner">
      <QSLoading
        :isLoading="loading.allData"
        :size="45"
        :colorTheme="colorTheme"
      />
    </div>
    <div v-else-if="data.companyFiles.length === 0">
      No Data Available
    </div>
    <div class="row f-row container-parameterized-files" v-else>
      <div class="col col-4 first-column">
        <CompanyFileManager
          :infoCompanyFiles="data.companyFiles"
          :defaultSelectedFile="formatVars.defaultFileNameSelected"
          @onFileName="changeFileName"
        />
      </div>
      <div class="col col-8 second-column">
        <FilePreviewVue
          :urlFile="formatVars.urlFile"
          :urlImg="formatVars.urlImg"
          :sheetName="formatVars.sheetName"
          :showTradeDate="formatVars.isTradeDate"
          :companyName="companyInformation.companyName"
          :canClearTradeDate="formatVars.canClearTradeDate"
          :isFocusCalendar="formatVars.isFocusCalendar"
          @handleTradeDate="handleTradeDate"
        />
        <FileManagerVue
          :fileName="formatVars.fileNameSelected"
          :isValidUpload="formatVars.isValidUpload"
          @onFileUpload="onFileUpload"
          @handleSelectFile="handleSelectFile"
          @handleFileUpload="handleFileUpload"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CompanyFileManager from "./CompanyFileManager.vue";
import FileManagerVue from "./FileManager.vue";
import FilePreviewVue from "./FilePreview.vue";
import { getFilesByCompany } from "@/_core/data/api_calls/getFilesByCompany";
import { FileManager } from "./CompanyFileManagers";
import { timeFormat } from "d3";
import { checkPortfolio } from "@/_core/data/SaveToDB.js";
import Messages from "../../modals/Messages.vue";
import QSLoading from "@/components/QSLoading.vue";

export default {
  name: "UploadFile",
  components: {
    CompanyFileManager,
    FileManagerVue,
    FilePreviewVue,
    Messages,
    QSLoading,
  },
  props: {
    colorTheme: { required: true, type: Boolean, default: true },
    companyInformation: {
      required: true,
      default: { idCompany: 0, companyName: "" },
    },
    isCurrency: { required: false, default: "currencies" },
  },
  data() {
    return {
      data: {
        companyFiles: [],
        CompanyFileManager: null,
      },
      formatVars: {
        canClearTradeDate: false,
        dataModelName: "",
        defaultFileNameSelected: "qs_expo",
        fileNameSelected: "",
        fileSelected: "",
        isFocusCalendar: null,
        isTradeDate: null,
        isValidUpload: null,
        sheetName: "",
        tradeDate: "",
        urlFile: "",
        urlImg: "",
      },
      loading: {
        allData: false,
        showModalLoading: false,
        messageModal: "",
        optionsModal: false,
      },
      user: [],
    };
  },
  created() {
    this.data.CompanyFileManager = new FileManager();

    const formatVars = this.formatVars;
    formatVars.fileNameSelected = formatVars.defaultFileNameSelected;
    try {
      this.user = this.$store.state.user.all.items;
    } catch (error) {
      console.log(`Error user ${error}`);
    }
  },
  mounted() {
    this.getAllData();
  },
  watch: {
    "data.companyFiles": {
      handler() {
        this.setAttrCompanyFileManager();
        this.searchCompanyFileSelected();
      },
      deep: true,
    },
    companyInformation: {
      handler() {
        this.changeCompany();
      },
      deep: true,
    },
    "formatVars.fileNameSelected": {
      handler() {
        this.searchCompanyFileSelected();
      },
      deep: true,
    },
  },
  methods: {
    /* Set methods */
    setAttrCompanyFileManager() {
      const data = this.data;
      const companyFile = data.CompanyFileManager;
      // Set the attributes of CompanyFileManager
      this.setIdCompany(companyFile);
      this.setInfoCompanyFile(companyFile, data);
      this.setSheetName(companyFile);
      this.setUrlFile(companyFile);
      this.setUrlImg(companyFile);
      this.validateTradeDate();
      this.canUpdateFile();
    },
    setIdCompany(companyFile) {
      companyFile.setIdCompany(this.companyInformation.idCompany);
    },
    setSheetName(companyFile) {
      companyFile.setSheetName(this.formatVars.fileNameSelected);
      this.getSheetName();
      this.validateTradeDate();
      this.canUpdateFile();
    },
    setInfoCompanyFile(companyFile, data) {
      companyFile.setInfoCompanyFile(data.companyFiles);
    },
    setUrlImg(filePrev) {
      filePrev.setURLImage(this.formatVars.fileNameSelected);
      this.getUrlImg();
    },
    setUrlFile(filePrev) {
      filePrev.setURLFile(this.formatVars.fileNameSelected);
      this.getUrlFile();
    },
    /* Get methods */
    getSheetName() {
      Object.assign(this.formatVars, {
        sheetName: this.data.CompanyFileManager.getSheetName(),
      });
    },
    getUrlImg() {
      Object.assign(this.formatVars, {
        urlImg: this.data.CompanyFileManager.getURLImage(),
      });
    },
    getUrlFile() {
      Object.assign(this.formatVars, {
        urlFile: this.data.CompanyFileManager.getURLFile(),
      });
    },
    getAllData() {
      // Get all the data of the selected company
      Object.assign(this.data, { companyFiles: [] });
      Object.assign(this.loading, { allData: true });
      const queryParams = {
        idCompany: this.companyInformation.idCompany,
        isCurrency: this.isCurrency,
      };
      getFilesByCompany(this, queryParams)
        .then(() => {
          this.setAttrCompanyFileManager();
        })
        .catch((e) => console.error(e));
    },
    /* Validate information */
    validateTradeDate() {
      // Validate if tradeDate is required
      Object.assign(this.formatVars, {
        isTradeDate: false,
      });
      const companyFile = this.data.CompanyFileManager;
      const fileName = this.formatVars.fileNameSelected;

      const isTradeDate = companyFile.validateTradeDate(fileName);
      setTimeout(() => {
        Object.assign(this.formatVars, {
          isTradeDate,
        });
      }, 0);
    },
    // determine if the file can be updated
    canUpdateFile() {
      const {
        fileSelected,
        fileNameSelected,
        tradeDate,
        isTradeDate,
      } = this.formatVars;
      // Early return if either fileSelected or fileNameSelected is falsy
      if (!fileSelected || !fileNameSelected) {
        this.formatVars.isValidUpload = false;
        return;
      }
      // If isTradeDate is true, validate tradeDate
      else if (isTradeDate) {
        this.formatVars.isValidUpload = tradeDate;
      } else {
        // If isTradeDate is false, assume valid upload
        this.formatVars.isValidUpload = true;
      }
    },
    /* Configuration data */
    clearValuesModal() {
      // Restore Modal values
      Object.assign(this.loading, {
        showModalLoading: false,
        messageModal: "",
        optionsModal: false,
      });
    },
    clearInputs() {
      const { isTradeDate } = this.formatVars;
      Object.assign(this.formatVars, {
        canClearTradeDate: isTradeDate,
      });
    },
    searchCompanyFileSelected() {
      // Search for the name (e.g. currencyhedge, etc.) of the selected file
      const findCompanyFile = this.data.companyFiles.find((d) =>
        d.file_data.some(
          (dd) => dd.file_name === this.formatVars.fileNameSelected,
        ),
      );
      if (findCompanyFile) {
        Object.assign(this.formatVars, {
          dataModelName: findCompanyFile.name,
        });
      }
    },
    postPortfolio() {
      const {
        dataModelName,
        fileNameSelected,
        fileSelected,
        isTradeDate,
        tradeDate,
      } = this.formatVars;

      const tradeDateObj = { "trade date": tradeDate };
      const additionalInfo = isTradeDate ? JSON.stringify(tradeDateObj) : "";

      checkPortfolio({
        _this: this,
        idCompany: this.companyInformation.idCompany,
        dataModelName,
        fileName: fileNameSelected,
        additionalInfo,
        fileData: fileSelected,
        idUser: this.user.pk_idusers,
      });
    },
    /* Events */
    handleSelectFile(file) {
      Object.assign(this.formatVars, {
        fileSelected: file,
      });
      this.canUpdateFile();
    },
    handleTradeDate(tradeDate) {
      if (tradeDate) {
        const formatDate = timeFormat("%Y-%m-%d");
        tradeDate = formatDate(tradeDate);
      }
      Object.assign(this.formatVars, {
        tradeDate,
      });
      this.canUpdateFile();
    },
    handleFileUpload(val) {
      this.formatVars.isFocusCalendar = val;
    },
    // Change the selected file
    changeFileName({ fileName }) {
      this.formatVars.fileNameSelected = fileName;

      const data = this.data;
      const companyFile = data.CompanyFileManager;
      //set the attributes sheetName, urlFile and urlImg
      this.setSheetName(companyFile);
      this.setUrlFile(companyFile);
      this.setUrlImg(companyFile);

      // Verify upload file
      this.canUpdateFile();
    },
    changeCompany() {
      this.clearInputs();
      const { defaultFileNameSelected } = this.formatVars;
      Object.assign(this.formatVars, {
        dataModelName: "",
        fileNameSelected: defaultFileNameSelected,
        sheetName: "",
        urlFile: "",
        urlImg: "",
      });
      this.formatVars.canClearTradeDate = false;
      this.getAllData();
    },
    onFileUpload() {
      this.postPortfolio();
      setTimeout(() => {
        this.clearInputs();
      }, 100);
    },
  },
};
</script>
